// pages/techNews.tsx
'use server';
import React, { Suspense, lazy } from 'react';
import styles from './techNews.module.scss';
import {RedditProvider} from '../Context/RedditContext'


const RedditPostContainer = lazy(() => import('../components/RedditPostContainer/RedditPostContainer'));

export default function TechNews() {
    return (
        <RedditProvider>
            <div className={styles.container}>
                <header className={styles.header}>
                    <h1 className={styles.title}>Technology News</h1>
                </header>
                <Suspense>
                    <RedditPostContainer />
                </Suspense>
            </div>
        </RedditProvider>
    );
}
